// extracted by mini-css-extract-plugin
export default {"default":"URDaJgvrYC8skbY6s78g","active":"BZizlONZKWTqq_tT7iRA URDaJgvrYC8skbY6s78g","tabBody":"nFaLc2_HT6WWxvycXKoG"};